export const Y_AXIS_INDEX = { left: 0, right: 1 } as const;

export const STYLE_PRESETS = {
  default: {
    colors: ["#1a73e8", "#ea4335", "#34a853", "#fbbc04", "#9334e6", "#ff6d01"],
    legend: {
      enabled: true,
      verticalAlign: "top",
      align: "center",
      itemStyle: { color: "#333" },
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        borderRadius: 0,
        groupPadding: 0.05,
        pointPadding: 0.05,
      },
    },
  },
};

export const AXES_PRESETS: Record<string, { yAxis: Record<string, unknown>[] }> = {
  single: {
    yAxis: [{ title: { text: "" }, labels: { style: { color: "#333" } }, plotLines: [] }],
  },
  dual: {
    yAxis: [
      { title: { text: "" }, labels: { style: { color: "#333" } }, plotLines: [] },
      { title: { text: "" }, opposite: true, labels: { style: { color: "#333" } }, plotLines: [] },
    ],
  },
};
